// colorThemeContext.tsx
import React, { createContext, useContext, useState, useEffect } from 'react';

// Define types first
// type ColorValue = [string, string]; // [major, minor]

// type ColorScheme = {
//     [key: string]: ColorValue;
// };

export type ColorScheme = {
    R: string[];
    m2: string[];
    M2: string[];
    m3: string[];
    M3: string[];
    P4: string[];
    d5: string[];
    P5: string[];
    m6: string[];
    M6: string[];
    m7: string[];
    M7: string[];
};

// const defaultSoft = {
//     R: 'rgb(255, 255, 255)', // Root
//     m2: 'rgb(244, 89, 78)', // Minor second 220, 70, 70
//     M2: 'rgb(240, 190, 50)', // Major second 230, 180, 105
//     m3: 'rgb(100, 160, 240)', // Minor third 112, 165, 255 (90, 145, 240)
//     M3: 'rgb(245, 245, 65)', // Major third 245, 245, 105
//     P4: 'rgb(140, 210, 110)', // Perfect fourth 155, 190, 130
//     d5: 'rgb(190, 160, 255)', // Diminished fifth/tritone (50, 230, 230) (225, 160, 255) (190, 160, 255)
//     P5: 'rgb(190, 190, 190)', // Perfect fifth 180, 180, 180
//     m6: 'rgb(180, 85, 180)', // Minor sixth 170, 85, 170 (140, 110, 235) (180, 85, 180)
//     M6: 'rgb(240, 145, 65)', // Major sixth 240, 150, 65
//     m7: 'rgb(90, 185, 175)', // Minor seventh
//     M7: 'rgb(255, 170, 200)', // Major seventh (220, 140, 180)

// Default colors
const defaultSoft: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'], // Root [major, minor]
    m2: ['rgb(244, 89, 78)', 'rgb(244, 89, 78)'], // Minor second
    M2: ['rgb(240, 190, 50)', 'rgb(240, 190, 50)'], // Major second
    m3: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'], // Minor third
    M3: ['rgb(245, 245, 65)', 'rgb(245, 245, 65)'], // Major third
    P4: ['rgb(140, 210, 110)', 'rgb(140, 210, 110)'], // Perfect fourth
    d5: ['rgb(190, 160, 255)', 'rgb(190, 160, 255)'], // Diminished fifth/tritone
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'], // Perfect fifth
    m6: ['rgb(180, 85, 180)', 'rgb(180, 85, 180)'], // Minor sixth
    M6: ['rgb(240, 145, 65)', 'rgb(240, 145, 65)'], // Major sixth
    m7: ['rgb(90, 185, 175)', 'rgb(90, 185, 175)'], // Minor seventh
    M7: ['rgb(255, 170, 200)', 'rgb(255, 170, 200)'], // Major seventh
};

// Default colors
const defaultSoftMajMin: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'], // Root [major, minor]
    m2: ['rgb(244, 89, 78)', 'rgb(180, 85, 121)'], // Minor second
    M2: ['rgb(240, 190, 50)', 'rgb(255, 170, 200)'], // Major second
    m3: ['rgb(100, 160, 255)', 'rgb(70, 163, 255)'], // Minor third
    M3: ['rgb(255, 255, 120)', 'rgb(244, 89, 78)'], // Major third
    P4: ['rgb(136, 213, 81)', 'rgb(172, 210, 110)'], // Perfect fourth
    d5: ['rgb(0, 255, 213)', 'rgb(169, 138, 255)'], // Diminished fifth/tritone
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'], // Perfect fifth
    m6: ['rgb(180, 85, 180)', 'rgb(180, 85, 180)'], // Minor sixth
    M6: ['rgb(240, 145, 65)', 'rgb(0, 255, 213)'], // Major sixth
    m7: ['rgb(70, 178, 182)', 'rgb(90, 185, 112)'], // Minor seventh 90, 185, 175
    M7: ['rgb(255, 170, 200)', 'rgb(190, 160, 255)'], // Major seventh
};

// Default colors Spectrum
const defaultSpectrum: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(220, 123, 162)', 'rgb(220, 123, 162)'],
    M2: ['rgb(140, 214, 123)', 'rgb(140, 214, 123)'],
    m3: ['rgb(123, 123, 220)', 'rgb(123, 123, 220)'],
    M3: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    P4: ['rgb(123, 187, 214)', 'rgb(123, 187, 214)'],
    d5: ['rgb(220, 149, 123)', 'rgb(220, 149, 123)'],
    P5: ['rgb(123, 214, 173)', 'rgb(123, 214, 173)'],
    m6: ['rgb(190, 123, 220)', 'rgb(190, 123, 220)'],
    M6: ['rgb(191, 214, 123)', 'rgb(191, 214, 123)'],
    m7: ['rgb(123, 156, 214)', 'rgb(123, 156, 214)'],
    M7: ['rgb(255, 194, 120)', 'rgb(255, 194, 120)']
};

// Synesthete SynTEigsti locked color spectrum
const defaultSynTEigsti: ColorScheme = {
    R: ['rgb(183, 187, 202)', 'rgb(183, 187, 202)'],
    m2: ['rgb(45, 119, 153)', 'rgb(45, 119, 153)'],
    M2: ['rgb(0, 210, 229)', 'rgb(0, 210, 229)'],
    m3: ['rgb(150, 65, 86)', 'rgb(150, 65, 86)'],
    M3: ['rgb(204, 112, 51)', 'rgb(204, 112, 51)'],
    P4: ['rgb(61, 63, 181)', 'rgb(61, 63, 181)'],
    d5: ['rgb(120, 57, 151)', 'rgb(120, 57, 151)'],
    P5: ['rgb(242, 65, 65)', 'rgb(242, 65, 65)'],
    m6: ['rgb(181, 98, 49)', 'rgb(181, 98, 49)'],
    M6: ['rgb(223, 161, 0)', 'rgb(223, 161, 0)'],
    m7: ['rgb(85, 110, 160)', 'rgb(85, 110, 160)'],
    M7: ['rgb(132, 204, 225)', 'rgb(132, 204, 225)']
};

// Synesthete SynHFeraud locked color spectrum
const defaultSynHFeraud: ColorScheme = {
    R: ['rgb(255, 152, 36)', 'rgb(255, 152, 36)'],
    m2: ['rgb(148, 253, 182)', 'rgb(148, 253, 182)'],
    M2: ['rgb(251, 219, 3)', 'rgb(251, 219, 3)'],
    m3: ['rgb(0, 198, 142)', 'rgb(0, 198, 142)'],
    M3: ['rgb(224, 43, 2)', 'rgb(224, 43, 2)'],
    P4: ['rgb(49, 74, 199)', 'rgb(49, 74, 199)'],
    d5: ['rgb(164, 0, 185)', 'rgb(164, 0, 185)'],
    P5: ['rgb(241, 84, 3)', 'rgb(241, 84, 3)'],
    m6: ['rgb(94, 139, 253)', 'rgb(94, 139, 253)'],
    M6: ['rgb(0, 0, 255)', 'rgb(0, 0, 255)'],
    m7: ['rgb(211, 185, 17)', 'rgb(211, 185, 17)'],
    M7: ['rgb(223, 253, 252)', 'rgb(223, 253, 252)']
};

// Testing Major vs Minor colors
const defaultMajMin: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M2: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    m3: ['rgb(100, 160, 240)', 'rgb(73, 152, 254)'],
    M3: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    P4: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    d5: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    m6: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M6: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    m7: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M7: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)']
};

// Testing Major vs Minor colors
const defaultFollowModeHarsh: ColorScheme = {
    R: ['rgb(255, 255, 120)', 'rgb(73, 152, 254)'],
    m2: ['rgb(231, 231, 108)', 'rgb(66, 136, 227)'],
    M2: ['rgb(255, 255, 190)', 'rgb(122, 180, 255)'],
    m3: ['rgb(185, 185, 86)', 'rgb(51, 108, 181)'],
    M3: ['rgb(255, 255, 190)', 'rgb(122, 180, 255)'],
    P4: ['rgb(231, 231, 108)', 'rgb(66, 136, 227)'],
    d5: ['rgb(255, 255, 120)', 'rgb(73, 152, 254)'],
    P5: ['rgb(255, 255, 150)', 'rgb(101, 168, 255)'],
    m6: ['rgb(203, 203, 95)', 'rgb(57, 118, 197)'],
    M6: ['rgb(255, 255, 210)', 'rgb(147, 194, 255)'],
    m7: ['rgb(203, 203, 95)', 'rgb(57, 118, 197)'],
    M7: ['rgb(255, 255, 150)', 'rgb(101, 168, 255)']
};

// Testing Major alternate colors
const defaultMajor: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M2: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    m3: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M3: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    P4: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    d5: ['rgb(85, 234, 204)', 'rgb(85, 234, 204)'],
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    m6: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M6: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
    m7: ['rgb(240, 145, 65)', 'rgb(240, 145, 65)'],
    M7: ['rgb(255, 170, 200)', 'rgb(255, 170, 200)']
};

// Testing Minor alternate colors
const defaultMinor: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M2: ['rgb(255, 170, 200)', 'rgb(255, 170, 200)'],
    m3: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M3: ['rgb(244, 89, 78)', 'rgb(244, 89, 78)'],
    P4: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    d5: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    m6: ['rgb(100, 160, 240)', 'rgb(100, 160, 240)'],
    M6: ['rgb(85, 234, 204)', 'rgb(85, 234, 204)'],
    m7: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    M7: ['rgb(85, 234, 204)', 'rgb(85, 234, 204)']
};

// Testing emotion group colors
// const defaultEmoGroups: ColorScheme = {
//     R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
//     m2: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
//     M2: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
//     m3: ['rgb(73, 152, 254)', 'rgb(73, 152, 254)'],
//     M3: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
//     P4: ['rgb(90, 185, 175)', 'rgb(90, 185, 175)'],
//     d5: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
//     P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
//     m6: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
//     M6: ['rgb(255, 255, 120)', 'rgb(255, 255, 120)'],
//     m7: ['rgb(90, 185, 175)', 'rgb(90, 185, 175)'],
//     M7: ['rgb(255, 170, 200)', 'rgb(255, 170, 200)']
// };

// Testing emotion group colors
const defaultEmoGroups: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M2: ['rgb(255, 255, 120)', 'rgb(255, 170, 200)'],
    m3: ['rgb(73, 152, 254)', 'rgb(73, 152, 254)'],
    M3: ['rgb(255, 255, 120)', 'rgb(244, 89, 78)'],
    P4: ['rgb(233, 174, 85)', 'rgb(190, 190, 190)'],
    d5: ['rgb(50, 230, 230)', 'rgb(188, 136, 255)'],
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    m6: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M6: ['rgb(255, 255, 120)', 'rgb(50, 230, 230)'],
    m7: ['rgb(240, 145, 65)', 'rgb(190, 190, 190)'],
    M7: ['rgb(255, 170, 200)', 'rgb(73, 152, 254)']
};

// Testing emotion group colors
const defaultEmoGroupsMinor: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M2: ['rgb(255, 170, 200)', 'rgb(255, 170, 200)'],
    m3: ['rgb(73, 152, 254)', 'rgb(73, 152, 254)'],
    M3: ['rgb(244, 89, 78)', 'rgb(244, 89, 78)'],
    P4: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    d5: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    P5: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    m6: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M6: ['rgb(50, 230, 230)', 'rgb(50, 230, 230)'],
    m7: ['rgb(190, 190, 190)', 'rgb(190, 190, 190)'],
    M7: ['rgb(73, 152, 254)', 'rgb(73, 152, 254)']
};

// Testing emotion group colors
const defaultValenceBright: ColorScheme = {
    R: ['rgb(225, 189, 89)', 'rgb(141, 156, 151)'],
    m2: ['rgb(52, 105, 147)', 'rgb(58, 116, 168)'],
    M2: ['rgb(248, 199, 74)', 'rgb(150, 164, 152)'],
    m3: ['rgb(130, 140, 131)', 'rgb(108, 151, 168)'],
    M3: ['rgb(240, 195, 73)', 'rgb(113, 147, 165)'],
    P4: ['rgb(211, 184, 95)', 'rgb(171, 175, 143)'],
    d5: ['rgb(239, 196, 88)', 'rgb(79, 139, 182)'],
    P5: ['rgb(208, 185, 102)', 'rgb(164, 175, 161)'],
    m6: ['rgb(199, 177, 100)', 'rgb(151, 176, 165)'],
    M6: ['rgb(250, 203, 86)', 'rgb(239, 208, 116)'],
    m7: ['rgb(179, 173, 118)', 'rgb(199, 189, 135)'],
    M7: ['rgb(194, 176, 101)', 'rgb(79, 136, 179)']
};

// // Testing Valence Dark colors
// const defaultValenceDark: ColorScheme = {
//     R: ['rgb(205, 167, 59)', 'rgb(84, 108, 101)'],
//     m2: ['rgb(34, 82, 120)', 'rgb(18, 75, 125)'],
//     M2: ['rgb(233, 181, 48)', 'rgb(94, 114, 97)'],
//     m3: ['rgb(95, 113, 98)', 'rgb(56, 95, 111)'],
//     M3: ['rgb(222, 175, 51)', 'rgb(62, 98, 117)'],
//     P4: ['rgb(183, 156, 65)', 'rgb(121, 126, 89)'],
//     d5: ['rgb(215, 172, 61)', 'rgb(29, 82, 120)'],
//     P5: ['rgb(179, 154, 67)', 'rgb(104, 118, 100)'],
//     m6: ['rgb(174, 151, 69)', 'rgb(86, 110, 101)'],
//     M6: ['rgb(235, 182, 47)', 'rgb(194, 161, 62)'],
//     m7: ['rgb(141, 135, 81)', 'rgb(151, 140, 78)'],
//     M7: ['rgb(169, 149, 70)', 'rgb(30, 81, 120)']
// };

// Testing Extensions colors
const defaultExtensions: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M2: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
    m3: ['rgb(188, 136, 255)', 'rgb(73, 152, 254)'],
    M3: ['rgb(255, 255, 120)', 'rgb(188, 136, 255)'],
    P4: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
    d5: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    P5: ['rgb(255, 255, 120)', 'rgb(100, 160, 240)'],
    m6: ['rgb(188, 136, 255)', 'rgb(188, 136, 255)'],
    M6: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
    m7: ['rgb(255, 255, 120)', 'rgb(73, 152, 254)'],
    M7: ['rgb(255, 255, 120)', 'rgb(188, 136, 255)']
};

// Testing Extensions colors
// const defaultExtensions: ColorScheme = {
//     R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
//     m2: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     M2: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     m3: ['rgb(85, 234, 204)', 'rgb(73, 152, 254)'],
//     M3: ['rgb(255, 255, 120)', 'rgb(94, 206, 194)'],
//     P4: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     d5: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     P5: ['rgb(255, 255, 120)', 'rgb(100, 160, 240)'],
//     m6: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     M6: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     m7: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)'],
//     M7: ['rgb(85, 234, 204)', 'rgb(94, 206, 194)']
// };

// Testing uniform color
const defaultUniformTeal: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    M2: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    m3: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    M3: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    P4: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    d5: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    P5: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    m6: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    M6: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    m7: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)'],
    M7: ['rgb(123, 198, 214)', 'rgb(123, 198, 214)']
};

// Testing uniform color
const defaultUniformOrange: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    M2: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    m3: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    M3: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    P4: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    d5: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    P5: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    m6: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    M6: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    m7: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)'],
    M7: ['rgb(242, 166, 90)', 'rgb(242, 166, 90)']
};

// Testing uniform color
const defaultUniformWhite: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    M2: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m3: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    M3: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    P4: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    d5: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    P5: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m6: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    M6: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m7: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    M7: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)']
};

// Testing uniform color
const defaultFollowModeSoft: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    M2: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    m3: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    M3: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    P4: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    d5: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    P5: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    m6: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    M6: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    m7: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)'],
    M7: ['rgb(253, 226, 152)', 'rgb(172, 198, 242)']
};

const defaultFollowModeSoftLight: ColorScheme = {
    R: ['rgb(246, 196, 45)', 'rgb(102, 171, 255)'],
    m2: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    M2: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    m3: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    M3: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    P4: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    d5: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    P5: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    m6: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    M6: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    m7: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)'],
    M7: ['rgb(253, 226, 152)', 'rgb(144, 185, 255)']
};

// const defaultSoftShadow = {
//     R: 'rgb(140, 140, 140)', // Root
//     m2: 'rgb(185, 60, 60)', // Minor second
//     M2: 'rgb(189, 160, 87)', // Major second
//     m3: 'rgb(88, 128, 196)', // Minor third
//     M3: 'rgb(189, 189, 81)', // Major third
//     P4: 'rgb(99, 148, 68)', // Perfect fourth
//     d5: 'rgb(35, 168, 168)', // Diminished fifth/tritone
//     P5: 'rgb(110, 103, 95)', // Perfect fifth
//     m6: 'rgb(130, 65, 130)', // Minor sixth
//     M6: 'rgb(186, 116, 50)', // Major sixth
//     m7: 'rgb(67, 140, 117)', // Minor seventh
//     M7: 'rgb(171, 108, 139)', // Major seventh
// };

const defaultHard: ColorScheme = {
    R: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)'],
    m2: ['rgb(225, 0, 0)', 'rgb(225, 0, 0)'],
    M2: ['rgb(255, 160, 0)', 'rgb(255, 160, 0)'],
    m3: ['rgb(62, 62, 255)', 'rgb(62, 62, 255)'],
    M3: ['rgb(255, 255, 0)', 'rgb(255, 255, 0)'],
    P4: ['rgb(85, 210, 0)', 'rgb(85, 210, 0)'],
    d5: ['rgb(0, 235, 235)', 'rgb(0, 235, 235)'],
    P5: ['rgb(150, 140, 130)', 'rgb(150, 140, 130)'],
    m6: ['rgb(170, 30, 170)', 'rgb(170, 30, 170)'],
    M6: ['rgb(255, 115, 0)', 'rgb(255, 115, 0)'],
    m7: ['rgb(0, 150, 125)', 'rgb(0, 150, 125)'],
    M7: ['rgb(255, 105, 175)', 'rgb(255, 105, 175)']
};

// Choose which palette to use as default
const initialColorPalette: ColorScheme = defaultSoftMajMin;
// const activeColorPalette: ColorScheme = defaultFollowMode;

const allPalettes = {
    defaultSoft,
    // defaultSoftShadow,
    defaultHard
};

interface ColorContextType {
    colors: ColorScheme;
    softColors: ColorScheme;
    softMajMinColors: ColorScheme;
    spectrumColors: ColorScheme;
    synTEigstiColors: ColorScheme;
    synHFeraudColors: ColorScheme;
    majMinColors: ColorScheme;
    majorColors: ColorScheme;
    minorColors: ColorScheme;
    emoGroupsColors: ColorScheme;
    emoGroupsMinColors: ColorScheme;
    uniformTealColors: ColorScheme;
    uniformWhiteColors: ColorScheme;
    uniformOrangeColors: ColorScheme;
    valenceBrightColors: ColorScheme;
    // valenceDarkColors: ColorScheme;
    extensionsColors: ColorScheme;
    followModeSoftColors: ColorScheme;
    followModeSoftLightColors: ColorScheme;
    followModeHarshColors: ColorScheme;
    customColors1: ColorScheme;
    // softShadowColors: typeof defaultSoftShadow;
    hardColors: ColorScheme;
    updateColors: (newColors: Partial<ColorScheme>) => void;
    setColorScheme: (scheme: ColorScheme) => void;
    transformPalette: (targetR: number, targetG: number, targetB: number, ratio?: number) => void;
    chordMode: number;
}

// Function to compute a shadow/darker version of a color
export function computeShadowColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 20;
    const targetG = 20;
    const targetB = 40;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r + targetR * 1) / 1.4); // 1.4
    const avgG = Math.floor((g + targetG * 1) / 1.4); // 1.4
    const avgB = Math.floor((b + targetB * 1) / 1.4); // 1.4

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

export function computeBlackKeyColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 0;
    const targetG = 0;
    const targetB = 0;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r * 5 + targetR * 1) / 6.0);
    const avgG = Math.floor((g * 5 + targetG * 1) / 6.0);
    const avgB = Math.floor((b * 5 + targetB * 1) / 6.0);

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

export function computeBlackKeyShadowColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 30;
    const targetG = 30;
    const targetB = 30;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r + targetR * 2) / 3);
    const avgG = Math.floor((g + targetG * 2) / 3);
    const avgB = Math.floor((b + targetB * 2) / 3);

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

function computeMinorTintColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 35;
    const targetG = 50;
    const targetB = 100;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r + targetR * 3) / 4);
    const avgG = Math.floor((g + targetG * 3) / 4);
    const avgB = Math.floor((b + targetB * 3) / 4);

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

function computeBlackKeyMinorShadowColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 35;
    const targetG = 50;
    const targetB = 100;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r + targetR * 3) / 4);
    const avgG = Math.floor((g + targetG * 3) / 4);
    const avgB = Math.floor((b + targetB * 3) / 4);

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

function transformColorPalette(palette: ColorScheme, targetR: number, targetG: number, targetB: number, ratio: number = 4): ColorScheme {
    const transformedPalette = { ...palette };

    Object.entries(palette).forEach(([key, value]) => {
        const rgbMatch = value[0].match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
        if (!rgbMatch) return;

        const r = parseInt(rgbMatch[1], 10);
        const g = parseInt(rgbMatch[2], 10);
        const b = parseInt(rgbMatch[3], 10);

        // Calculate the weighted average between the input color and target color
        const avgR = Math.floor((r * (ratio - 1) + targetR) / ratio);
        const avgG = Math.floor((g * (ratio - 1) + targetG) / ratio);
        const avgB = Math.floor((b * (ratio - 1) + targetB) / ratio);

        transformedPalette[key as keyof ColorScheme] = [
            `rgb(${avgR}, ${avgG}, ${avgB})`,
            transformedPalette[key as keyof ColorScheme][1]
        ];
    });

    return transformedPalette;
}

// Function to compute a lighter Overtone version of a color
export function computeOvertoneColor(rgbColor: string): string {
    // Parse the RGB color
    const rgbMatch = rgbColor.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    if (!rgbMatch) return rgbColor; // Return original if not a valid RGB color

    // Extract RGB components
    const r = parseInt(rgbMatch[1], 10);
    const g = parseInt(rgbMatch[2], 10);
    const b = parseInt(rgbMatch[3], 10);

    // Fixed target color values
    const targetR = 190;
    const targetG = 190;
    const targetB = 190;

    // Calculate the average between the input color and target color
    const avgR = Math.floor((r + targetR * 1) / 4); // 
    const avgG = Math.floor((g + targetG * 1) / 4); // 
    const avgB = Math.floor((b + targetB * 1) / 4); // 

    return `rgb(${avgR}, ${avgG}, ${avgB})`;
}

const ColorContext = createContext<ColorContextType | undefined>(undefined);

export const ColorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [colors, setColors] = useState<ColorScheme>(initialColorPalette);

    // Update CSS variables whenever colors change
    useEffect(() => {
        // Set current active colors
        Object.entries(colors).forEach(([key, value]) => {
            // Set base colors (for backward compatibility with other components)
            document.documentElement.style.setProperty(`--color-${key}`, value[0]); // Default to major
            document.documentElement.style.setProperty(`--color-${key}-shadow`, computeShadowColor(value[0]));
            document.documentElement.style.setProperty(`--color-${key}-black`, computeBlackKeyColor(value[0]));
            document.documentElement.style.setProperty(`--color-${key}-black-shadow`, computeBlackKeyShadowColor(value[0]));

            // Also set major/minor variables for components that might still need them
            document.documentElement.style.setProperty(`--color-${key}-major`, value[0]);
            document.documentElement.style.setProperty(`--color-${key}-minor`, value[1]);
        });
    }, [colors]);

    // Set entire color scheme at once
    const setColorScheme = (scheme: ColorScheme) => {
        setColors(scheme);
        if ('requestIdleCallback' in window) {
            (window as any).requestIdleCallback(() => {
                saveColorPreferences(scheme);
            });
        } else {
            setTimeout(() => {
                saveColorPreferences(scheme);
            }, 0);
        }
    };

    // For updating individual colors
    const updateColors = (newColors: Partial<ColorScheme>) => {
        setColors(prevColors => {
            const updatedColors: ColorScheme = { ...prevColors };
            Object.entries(newColors).forEach(([key, value]) => {
                if (value) {
                    updatedColors[key as keyof ColorScheme] = value;
                }
            });
            if ('requestIdleCallback' in window) {
                (window as any).requestIdleCallback(() => {
                    saveColorPreferences(updatedColors);
                });
            } else {
                setTimeout(() => {
                    saveColorPreferences(updatedColors);
                }, 0);
            }
            return updatedColors;
        });
    };

    // Load saved colors on initial load
    useEffect(() => {
        const loadSavedColors = async () => {
            try {
                // This could be localStorage or an API call to your database
                const savedColors = await loadColorPreferences();
                if (savedColors) {
                    setColors(savedColors);
                }
            } catch (error) {
                console.error('Failed to load color preferences:', error);
            }
        };

        loadSavedColors();
    }, []);

    const transformPalette = (targetR: number, targetG: number, targetB: number, ratio: number = 4) => {
        // Always start from defaultSoft palette instead of current colors
        const newColors = transformColorPalette(colors, targetR, targetG, targetB, ratio);
        setColors(newColors);
        saveColorPreferences(newColors);
    };

    return (
        <ColorContext.Provider value={{
            colors,
            softColors: defaultSoft,
            softMajMinColors: defaultSoftMajMin,
            spectrumColors: defaultSpectrum,
            synTEigstiColors: defaultSynTEigsti,
            synHFeraudColors: defaultSynHFeraud,
            majMinColors: defaultMajMin,
            majorColors: defaultMajor,
            minorColors: defaultMinor,
            emoGroupsColors: defaultEmoGroups,
            emoGroupsMinColors: defaultEmoGroupsMinor,
            valenceBrightColors: defaultValenceBright,
            // valenceDarkColors: defaultValenceDark,
            extensionsColors: defaultExtensions,
            uniformTealColors: defaultUniformTeal,
            uniformWhiteColors: defaultUniformWhite,
            uniformOrangeColors: defaultUniformOrange,
            followModeSoftColors: defaultFollowModeSoft,
            followModeSoftLightColors: defaultFollowModeSoftLight,
            followModeHarshColors: defaultFollowModeHarsh,
            // softShadowColors: defaultSoftShadow,
            hardColors: defaultHard,
            customColors1: defaultSoftMajMin,
            updateColors,
            setColorScheme,
            transformPalette,
            chordMode: 0
        }}>
            {children}
        </ColorContext.Provider>
    );
};

// Custom hook for easy access to the color context
export const useColors = () => {
    const context = useContext(ColorContext);
    if (context === undefined) {
        throw new Error('useColors must be used within a ColorProvider');
    }
    return context;
};

// These functions would connect to your database or localStorage
const saveColorPreferences = (colors: ColorScheme) => {
    localStorage.setItem('userColorPreferences', JSON.stringify(colors));
    // If using a database:
    // await api.updateUserPreferences({ colors });
};

const loadColorPreferences = (): Promise<ColorScheme | null> => {
    // const saved = localStorage.getItem('userColorPreferences');
    return Promise.resolve(null);
    // If using a database:
    // return api.getUserPreferences().then(data => data.colors);
};